import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar'; // Memastikan komponen Sidebar bawaan Anda ter-import dengan benar

// 8 Menu lengkap sesuai gambar dengan Ikon SVG profesional
const navItems = [
  { label: 'Dashboard', path: '/admin', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect></svg> },
  { label: 'Laporan', path: '/admin/laporan', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg> },
  { label: 'Pasien', path: '/admin/pasien', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg> },
  { label: 'Dokter', path: '/admin/dokter', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 12h-4l-3 9L9 3l-3 9H2"></path></svg> },
  { label: 'Pendaftaran', path: '/admin/pendaftaran', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect></svg> },
  { label: 'Rekam Medis', path: '/admin/rekam-medis', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><path d="M14 2v6h6"></path><path d="M16 13H8"></path><path d="M16 17H8"></path><path d="M10 9H8"></path></svg> },
  { label: 'Transaksi', path: '/admin/transaksi', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line></svg> },
  { label: 'Tarif', path: '/admin/tarif', icon: <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg> },
];

const AdminLayout = ({ title, children }) => {
  const [isMobile, setIsMobile] = useState(false);
  const [currentPath, setCurrentPath] = useState('');

  useEffect(() => {
    setCurrentPath(window.location.pathname);

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    handleResize(); 
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('token');
    window.location.replace('/login');
  };

  const laporanMenus = [
    { id: 1, title: 'Laporan Pasien', desc: 'Ringkasan data pasien dan aktivitas pendaftaran.', path: '/admin/laporan/pasien', btnLabel: 'Laporan Pasien' },
    { id: 2, title: 'Laporan Rekam Medis', desc: 'Rekam medis pasien sebagai dasar pemeriksaan dan diagnosis.', path: '/admin/laporan/rekam-medis', btnLabel: 'Laporan Rekam Medis' },
    { id: 3, title: 'Laporan Dokter', desc: 'Statistik pasien dan kehadiran dokter setiap hari.', path: '/admin/laporan/dokter', btnLabel: 'Laporan Dokter' },
    { id: 4, title: 'Laporan Pendaftaran', desc: 'Analisis status pendaftaran dan antrean.', path: '/admin/laporan/pendaftaran', btnLabel: 'Laporan Pendaftaran' },
    { id: 5, title: 'Laporan Transaksi', desc: 'Ringkasan pendapatan klinik dan pembayaran pasien.', path: '/admin/laporan/transaksi', btnLabel: 'Laporan Transaksi' },
  ];

  const isMainLaporanPage = currentPath === '/admin/laporan';

  return (
    <div style={{
      ...styles.layout,
      paddingBottom: isMobile ? '64px' : '0px'
    }}>

      {/* DESKTOP VIEW: SIDEBAR KIRI */}
      {!isMobile && (
        <div style={styles.sidebarWrapper}>
          <Sidebar />
        </div>
      )}

      {/* KONTEN UTAMA */}
      <main style={styles.content}>

        {/* HEADER AREA */}
        {isMainLaporanPage && (
          <div style={styles.header}>
            <div>
              <h1 style={styles.title}>Laporan Admin</h1>
              <p style={styles.subtitle}>Halaman ini menampilkan daftar laporan yang tersedia di dashboard admin. Pilih laporan untuk melihat data pasien, rekam medis, dokter, pendaftaran, dan transaksi secara detail.</p>
            </div>
            {isMobile && (
              <div style={styles.mobileHeaderUtils}>
                <button onClick={handleLogout} style={styles.mobileLogoutBtn}>Keluar</button>
              </div>
            )}
          </div>
        )}

        {/* BODY AREA */}
        <div style={styles.body}>
          
          {/* GRID CARDS ASLI SPERTI GAMBAR */}
          {isMainLaporanPage && (
            <div style={styles.cardGrid}>
              {laporanMenus.map((menu) => (
                <div key={menu.id} style={styles.reportCard}>
                  {/* Indikator Nomor Kotak Asli */}
                  <div style={styles.badgeNumberContainer}>
                    <span style={styles.badgeNumber}>{menu.id}</span>
                  </div>

                  {/* Konten Utama */}
                  <div style={styles.cardInnerContent}>
                    <h3 style={styles.cardTitle}>{menu.title}</h3>
                    <p style={styles.cardDesc}>{menu.desc}</p>
                  </div>

                  {/* Tombol Ungu/Biru Muda Asli */}
                  <a href={menu.path} style={styles.cardButton}>
                    {menu.btnLabel}
                  </a>
                </div>
              ))}
            </div>
          )}

          {/* TEMPAT HALAMAN DETAIL */}
          {children}
        </div>

      </main>

      {/* MOBILE VIEW: BOTTOM NAVIGATION BAR */}
      {isMobile && (
        <div style={styles.bottomNav}>
          {navItems.map((item, index) => {
            const isActive = currentPath.startsWith(item.path) && item.path !== '/admin' || currentPath === item.path;

            return (
              <a 
                key={index} 
                href={item.path} 
                style={{
                  ...styles.navLink,
                  color: isActive ? '#4f46e5' : '#64748b',
                  fontWeight: isActive ? '600' : '500'
                }}
              >
                <span style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: isActive ? '#4f46e5' : '#94a3b8'
                }}>
                  {item.icon}
                </span>
                <span style={styles.navLabel}>{item.label}</span>
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
};

/* ==========================================
   STYLES (KEMBALI ASLI SEPERTI DI GAMBAR)
   ========================================== */
const styles = {
  layout: {
    display: 'flex',
    height: '100vh',
    width: '100vw',
    overflow: 'hidden',
    background: '#f8fafc',
    position: 'relative',
    boxSizing: 'border-box'
  },

  sidebarWrapper: {
    width: '260px',
    minWidth: '260px',
    flexShrink: 0,
    height: '100%',
    zIndex: 10
  },

  content: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },

  header: {
    padding: '24px 32px',
    borderBottom: '1px solid #e2e8f0',
    background: '#ffffff',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexShrink: 0
  },

  title: {
    margin: 0,
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#1e293b'
  },

  subtitle: {
    margin: '6px 0 0 0',
    fontSize: '0.875rem',
    color: '#64748b',
    lineHeight: '1.5',
    maxWidth: '900px'
  },

  mobileHeaderUtils: {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto'
  },

  mobileLogoutBtn: {
    background: '#ffe4e6',
    color: '#e11d48',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '8px',
    fontSize: '0.8rem',
    fontWeight: '600',
    cursor: 'pointer'
  },

  body: {
    flex: 1,
    overflowY: 'auto', 
    padding: '32px',
    boxSizing: 'border-box'
  },

  cardGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
    gap: '20px',
    width: '100%',
    marginBottom: '24px',
    boxSizing: 'border-box'
  },

  reportCard: {
    background: '#ffffff',
    border: '1px solid #e2e8f0',
    borderRadius: '12px',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '250px', 
    boxShadow: '0 1px 3px rgba(0,0,0,0.01)',
    boxSizing: 'border-box'
  },

  badgeNumberContainer: {
    display: 'flex',
    justifyContent: 'center',
    background: '#f1f5f9', // Warna abu cerah asli kotak nomor
    borderRadius: '6px',
    padding: '6px 0',
    marginBottom: '14px',
    width: '100%'
  },

  badgeNumber: {
    fontSize: '0.875rem',
    fontWeight: '700',
    color: '#64748b'
  },

  cardInnerContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },

  cardTitle: {
    margin: '0 0 8px 0',
    fontSize: '1rem',
    fontWeight: '600',
    color: '#1e293b'
  },

  cardDesc: {
    margin: 0,
    fontSize: '0.825rem',
    color: '#64748b',
    lineHeight: '1.4',
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  },

  cardButton: {
    marginTop: '16px',
    display: 'block',
    textAlign: 'center',
    background: '#e0e7ff', // Warna latar tombol asli gambar Anda
    color: '#4f46e5', // Warna font tombol asli gambar Anda
    textDecoration: 'none',
    padding: '10px',
    borderRadius: '8px',
    fontSize: '0.85rem',
    fontWeight: '600',
    boxSizing: 'border-box'
  },

  bottomNav: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    height: '64px',
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    borderTop: '1px solid #e2e8f0',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    zIndex: 999,
    padding: '0 4px',
    overflowX: 'auto',              
    WebkitOverflowScrolling: 'touch' 
  },

  navLink: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textDecoration: 'none',
    fontSize: '9px',
    minWidth: '52px',
    flex: '1 0 auto',
    padding: '4px 0'
  },

  navLabel: {
    marginTop: '4px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '56px'
  }
};

export default AdminLayout;